import { render, staticRenderFns } from "./ReportingRestrictions.vue?vue&type=template&id=782a8033"
import script from "./ReportingRestrictions.vue?vue&type=script&lang=js"
export * from "./ReportingRestrictions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports